export enum ObservationrecordOriginEnum {
    MobileApp = 'MOBILEAPP',
    WebApp = 'WEBAPP'
}